var SEPARATOR = '.';
var PARTS = ['major', 'minor', 'build', 'patch'];
var EQUALS = 'equals';
var LESS_THAN = 'less_than';
var GREATER_THAN = 'greater_than';
export { SEPARATOR, PARTS, EQUALS, LESS_THAN, GREATER_THAN };